import { render, staticRenderFns } from "./AmountSources.vue?vue&type=template&id=3bf560ae&"
import script from "./AmountSources.vue?vue&type=script&lang=js&"
export * from "./AmountSources.vue?vue&type=script&lang=js&"
import style0 from "./AmountSources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports